exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span {\n\tpadding: 5px;\n\tcursor: pointer;\n\tfont-size: 14px;\n\tfont-weight: 200;\n}\n\napp-playhead{\n\tfloat: left;\n}\n.selected{\n\tfont-weight: 500;\n\ttext-decoration: underline;\n}\n\n.coloredDiv {\n  height:20px; width:20px; float:left;\n}\n\n#yAsis{\n\tmargin-left: -40px;\n}\n\n#name{\n\t//float: left;\n\tpadding-left: 10px;\n\theight: 20px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/d3graph/d3graph.component.css
// module id = ../../../../../src/app/d3graph/d3graph.component.css
// module chunks = main